import { Anchor as FoundationAnchor } from '@ni/fast-foundation';

/**
 * Exported base class of link-like types
 */
export class AnchorBase extends FoundationAnchor {}
